/**
 * @fileoverview PUT handler for the "/engagement/:app_group_id/banner_templates/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdBannerTemplatesIdCacheKeys } from "./constants";
import type {
  PutEngagementAppGroupIdBannerTemplatesIdProps,
  EngagementAppGroupIdBannerTemplatesIdResult,
} from "./types";

export const putEngagementAppGroupIdBannerTemplatesId = reactQueryMutationAdapter(
  engagementAppGroupIdBannerTemplatesIdCacheKeys,
  (props: PutEngagementAppGroupIdBannerTemplatesIdProps): Promise<EngagementAppGroupIdBannerTemplatesIdResult> => {
    return fetch(`/engagement/${props.app_group_id}/banner_templates/${props.id}`, "PUT", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
